import { Yup } from '@frontman/utils';

export const lifeInsuranceTypeSchema = Yup.object().shape({
  typeOfLifeInsurancePossessed: Yup.mixed()
    .oneOf(['term', 'cash_value', 'not_sure'])
    .required('Please select an option'),
});
